import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { ECollectionPageType } from '@src/pages/[...slug]/components/collection/services/collectionService/CollectionService.types'

// Slug types
export const SLUG_TYPE = {
  COLLECTION: 'collection',
  SUBCOLLECTION: 'subcollection',
  PRODUCT: 'product',
  HOME: 'homePage',
} as const

export type SlugType = (typeof SLUG_TYPE)[keyof typeof SLUG_TYPE]

// Feature flag types
export const FEATURE_FLAG_TYPE = {
  COLLECTION: 'collection',
  PRODUCT: 'product',
  NONE: 'none',
} as const

// URL placement types
export const URL_PLACEMENT = {
  PATH: 'path',
  QUERY: 'query',
} as const

// Filter types
export const FILTER_TYPE = {
  DRAWER: 'drawer',
  SIDEBAR: 'sidebar',
  DROPDOWN: 'dropdown',
  BOTTOM_SHEET: 'bottom-sheet',
  MODAL: 'modal',
} as const

// Type-safe literal types
export type FeatureFlagType = (typeof FEATURE_FLAG_TYPE)[keyof typeof FEATURE_FLAG_TYPE]
export type UrlPlacement = (typeof URL_PLACEMENT)[keyof typeof URL_PLACEMENT]
export type FilterType = (typeof FILTER_TYPE)[keyof typeof FILTER_TYPE]
export type DesktopFilterType = typeof FILTER_TYPE.DRAWER | typeof FILTER_TYPE.SIDEBAR | typeof FILTER_TYPE.DROPDOWN
export type MobileFilterType = typeof FILTER_TYPE.BOTTOM_SHEET | typeof FILTER_TYPE.MODAL

export interface ServerSideCommonFeatureFlags {
  isPersonalized: boolean
}
export interface ServerSideGlobalExperimentBucketMap {
  globalExperimentBucketMap: Partial<Record<STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_BUCKETS>>
}

export interface CollectionServerSideFeatureFlags
  extends ServerSideCommonFeatureFlags,
    ServerSideGlobalExperimentBucketMap {
  featureFlagType: typeof FEATURE_FLAG_TYPE.COLLECTION
  subCollectionUrlPlacement: UrlPlacement
  collectionPageType: ECollectionPageType
  filterType: FilterType
  isDynamicCollection: boolean
  bestSellerExperimentBucket: string | null
  clpFilterExperimentBucketMobile: string | null
  clpFilterExperimentBucketDesktop: string | null
  clpPersonalisationExperimentBucket: string | null
  velouFiltersExperimentBucket: string | null
}

export interface ProductServerSideFeatureFlags
  extends ServerSideCommonFeatureFlags,
    ServerSideGlobalExperimentBucketMap {
  featureFlagType: typeof FEATURE_FLAG_TYPE.PRODUCT
  miniPDPExperimentBucket: string | null
}

export interface ServerSideFeatureFlagsNone extends ServerSideCommonFeatureFlags, ServerSideGlobalExperimentBucketMap {
  featureFlagType: typeof FEATURE_FLAG_TYPE.NONE
}

export type ServerSideFeatureFlags =
  | CollectionServerSideFeatureFlags
  | ServerSideFeatureFlagsNone
  | ProductServerSideFeatureFlags
